import { ResponseService } from './response.service';
import { Router } from '@angular/router';
import { CoreService } from './core.service';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import { Company } from './../interfaces/company.model';
import { Injectable, Output, EventEmitter } from '@angular/core';
import { ReplaySubject } from 'rxjs/Rx';

@Injectable()
export class CompanyService {
  private _selectedCompany: Company;
  private oCompanies = new ReplaySubject(1);
  private companyData = new ReplaySubject(1);
  authEvent: any;

  @Output() private selectedCompanyEmitter = new EventEmitter();

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private coreService: CoreService,
    private responseService: ResponseService,
    private router: Router
  ) { 
    this.authEvent = this.authService.getAuthenticatedEmitter().subscribe(
      (auth) => {
        if (!auth) {
          this.resetState();
        }
      }
    );
  }

  getUserCompanies(forceRefresh?: boolean) {
    if (!this.oCompanies.observers.length || forceRefresh || this.coreService.refresh) {
      this.apiService.get('/companies').subscribe(
        (response) => {
          this.oCompanies.next(this.responseService.success(false, response, 'companies'));
        },
        (error) => {
          this.responseService.error(error);
          this.oCompanies = new ReplaySubject(1);
        }
      );
    }
    return this.oCompanies;
  }

  getCompany(id: number | string | object): any {
    return this.oCompanies.map(
      (companies: Company[]) => {
        return companies.find(company => company.id === id);
      },
      (error) => {
        return null;
      }
    );
  }

  getCompanyData(companyID, isCheckout = false) {
    this.apiService.get(`/${isCheckout ? 'checkout-' : ''}company/${companyID}`).subscribe(
      (response) => {
        let companyData = this.responseService.success(false, response, 'company');
        companyData['canEdit'] = response.data.can_edit;
        companyData['isOwner'] = response.data.is_owner;
        this.companyData.next(companyData);
      },
      (error) => {
        this.companyData = new ReplaySubject(1);
      }
    );

    return this.companyData;
  }

  public get selectedCompany(): Company {
    return this._selectedCompany;
  }

  public set selectedCompany(company: Company) {
    this._selectedCompany = company;
    this.selectedCompanyEmitter.emit(this._selectedCompany);
  }

  getSelectedCompanyEmitter() {
    return this.selectedCompanyEmitter;
  }

  public resetState() {
    this._selectedCompany = undefined;
    this.oCompanies = new ReplaySubject(1);
    this.companyData = new ReplaySubject(1);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/company.service.ts